import clsx from "clsx";
import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";
import classes from "./spinner-large.module.css";

export const SpinnerLargeIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          {...props}
          ref={ref}
          className={clsx(classes.root, className)}
        >
          <circle
            cx="17"
            cy="17"
            r="16"
            stroke="#c9d5e9"
            strokeOpacity="0.4"
            strokeWidth="2"
          />
          <path
            d="M17 1C8.16344 1 1 8.16344 1 17C1 21.2608 2.6655 25.1327 5.381 28"
            stroke="url(#paint0_linear_15821_35)"
            strokeWidth="2"
          />
          <defs>
            <linearGradient
              id="paint0_linear_15821_35"
              x1="2.5"
              y1="9"
              x2="-2.77559"
              y2="22.4272"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="currentColor" />
              <stop offset="1" stopColor="currentColor" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </Icon>
    );
  },
);

SpinnerLargeIcon.displayName = "SpinnerLargeIcon";
